export default __webpack_public_path__ + "static/media/Highlord's Sanctum.c52b874b.jpg";